export default __webpack_public_path__ + "static/media/cancel-line.519895bc.svg";